require("@bgs/App/WidgetExtensions/Addresses/AddressBook");
require("@bgs/App/WidgetExtensions/Addresses/CreateAddressButton");
require("@bgs/App/WidgetExtensions/Addresses/CurrentBillingAddress");
require("@bgs/App/WidgetExtensions/Addresses/CurrentShippingAddress");
require("@bgs/App/WidgetExtensions/Basic/SocialLinksExtension");
require("@bgs/App/WidgetExtensions/Brand/AlphabetNavigationExntesions");
require("@bgs/App/WidgetExtensions/Cart/CartLineCartExpandedExtensions");
require("@bgs/App/WidgetExtensions/Cart/CartLines");
require("@bgs/App/WidgetExtensions/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode");
require("@bgs/App/WidgetExtensions/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitShippingInfo");
require("@bgs/App/WidgetExtensions/CheckoutStepper/CheckoutStepper");
require("@bgs/App/WidgetExtensions/Common/HeaderShipToAddress");
require("@bgs/App/WidgetExtensions/Common/PurchasedProductsExtensions");
require("@bgs/App/WidgetExtensions/Header/HeaderLinkList");
require("@bgs/App/WidgetExtensions/Header/SecondaryNavigation");
require("@bgs/App/WidgetExtensions/MyCustomQuoteDetails/MyCustomQuoeDetailsOptionsExtensions");
require("@bgs/App/WidgetExtensions/MyCustomQuoteDetails/MyCustomQuoteDetailsActionsExtensions");
require("@bgs/App/WidgetExtensions/MyCustomQuotes/MyCustomQuotesListExtensions");
require("@bgs/App/WidgetExtensions/OrderConfirmation/OrderConfirmationPageExtension");
require("@bgs/App/WidgetExtensions/ProductCompare/ProductCompareCarousel");
require("@bgs/App/WidgetExtensions/ProductDetails/ProductDetailsQrCodeExtensions");
require("@bgs/App/WidgetExtensions/ProductDetails/ProductDetailsSuggestedProductsExtensions");
require("@bgs/App/WidgetExtensions/ProductList/ProductListSearchWithin");
require("@bgs/App/WidgetExtensions/QuickOrder/QuickOrderProductList");
require("@bgs/App/WidgetExtensions/RequestRma/RequestRmaButton");
require("@bgs/App/WidgetExtensions/UserList/UserListHeader");

const importChunkObj: any = {
	"AccountSettings/AccountSettingsDefaultBillingShipping": () => {
        return import(
            /* webpackChunkName: "accountsettingsChunk" */ "@insite/content-library/Widgets/AccountSettings/AccountSettingsDefaultBillingShipping"
        );
	},
	"AccountSettings/AccountSettingsHeader": () => {
        return import(
            /* webpackChunkName: "accountsettingsChunk" */ "@insite/content-library/Widgets/AccountSettings/AccountSettingsHeader"
        );
	},
	"AccountSettings/AccountSettingsManageSubscriptions": () => {
        return import(
            /* webpackChunkName: "accountsettingsChunk" */ "@insite/content-library/Widgets/AccountSettings/AccountSettingsManageSubscriptions"
        );
	},
	"AccountSettings/AccountSettingsUserInformation": () => {
        return import(
            /* webpackChunkName: "accountsettingsChunk" */ "@insite/content-library/Widgets/AccountSettings/AccountSettingsUserInformation"
        );
	},
	"AccountSettings/DefaultBillingAddress": () => {
        return import(
            /* webpackChunkName: "accountsettingsChunk" */ "@insite/content-library/Widgets/AccountSettings/DefaultBillingAddress"
        );
	},
	"AccountSettings/DefaultShippingAddress": () => {
        return import(
            /* webpackChunkName: "accountsettingsChunk" */ "@insite/content-library/Widgets/AccountSettings/DefaultShippingAddress"
        );
	},
	"AddressBookOverlay/AddressBook": () => {
        return import(
            /* webpackChunkName: "addressbookoverlayChunk" */ "@insite/content-library/Widgets/AddressBookOverlay/AddressBook"
        );
	},
	"Addresses/AddressBook": () => {
        return import(
            /* webpackChunkName: "addressesChunk" */ "@insite/content-library/Widgets/Addresses/AddressBook"
        );
	},
	"Addresses/AddressBookPagination": () => {
        return import(
            /* webpackChunkName: "addressesChunk" */ "@insite/content-library/Widgets/Addresses/AddressBookPagination"
        );
	},
	"Addresses/AddressBookSearchBox": () => {
        return import(
            /* webpackChunkName: "addressesChunk" */ "@insite/content-library/Widgets/Addresses/AddressBookSearchBox"
        );
	},
	"Addresses/CreateAddressButton": () => {
        return import(
            /* webpackChunkName: "addressesChunk" */ "@insite/content-library/Widgets/Addresses/CreateAddressButton"
        );
	},
	"Addresses/CurrentBillingAddress": () => {
        return import(
            /* webpackChunkName: "addressesChunk" */ "@insite/content-library/Widgets/Addresses/CurrentBillingAddress"
        );
	},
	"Addresses/CurrentShippingAddress": () => {
        return import(
            /* webpackChunkName: "addressesChunk" */ "@insite/content-library/Widgets/Addresses/CurrentShippingAddress"
        );
	},
	"Brand/AlphabetNavigation": () => {
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/Brand/AlphabetNavigation"
        );
	},
	"Brand/BrandAlphabetNavigation": () => {
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/Brand/BrandAlphabetNavigation"
        );
	},
	"Brand/BrandGallery": () => {
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/Brand/BrandGallery"
        );
	},
	"Brand/BrandList": () => {
        import(/* webpackChunkName: "brandsChunk" */ "@bgs/App/WidgetExtensions/Brand/BrandListExtensions");
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/Brand/BrandList"
        );
	},
	"Brand/FlexItem": () => {
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/Brand/FlexItem"
        );
	},
	"Brand/FlexWrapContainer": () => {
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/Brand/FlexWrapContainer"
        );
	},
	"BrandDetails/BrandDetailsCategories": () => {
        import(/* webpackChunkName: "brandsChunk" */ "@bgs/App/WidgetExtensions/BrandDetails/BrandDetailsCategoriesExtension");
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/BrandDetails/BrandDetailsCategories"
        );
	},
	"BrandDetails/BrandDetailsContent": () => {
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/BrandDetails/BrandDetailsContent"
        );
	},
	"BrandDetails/BrandDetailsImage": () => {
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/BrandDetails/BrandDetailsImage"
        );
	},
	"BrandDetails/BrandDetailsLogo": () => {
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/BrandDetails/BrandDetailsLogo"
        );
	},
	"BrandDetails/BrandDetailsProductLines": () => {
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/BrandDetails/BrandDetailsProductLines"
        );
	},
	"Budget/AssignBudgets": () => {
        return import(
            /* webpackChunkName: "budgetsChunk" */ "@insite/content-library/Widgets/Budget/AssignBudgets"
        );
	},
	"Budget/BudgetManagementHeader": () => {
        return import(
            /* webpackChunkName: "budgetsChunk" */ "@insite/content-library/Widgets/Budget/BudgetManagementHeader"
        );
	},
	"Budget/BudgetShipToDropdown": () => {
        return import(
            /* webpackChunkName: "budgetsChunk" */ "@insite/content-library/Widgets/Budget/BudgetShipToDropdown"
        );
	},
	"Budget/BudgetYearSelector": () => {
        return import(
            /* webpackChunkName: "budgetsChunk" */ "@insite/content-library/Widgets/Budget/BudgetYearSelector"
        );
	},
	"Budget/ConfigureBudget": () => {
        return import(
            /* webpackChunkName: "budgetsChunk" */ "@insite/content-library/Widgets/Budget/ConfigureBudget"
        );
	},
	"Budget/CostCodes": () => {
        return import(
            /* webpackChunkName: "budgetsChunk" */ "@insite/content-library/Widgets/Budget/CostCodes"
        );
	},
	"Budget/EnforcementLevelDisplay": () => {
        return import(
            /* webpackChunkName: "budgetsChunk" */ "@insite/content-library/Widgets/Budget/EnforcementLevelDisplay"
        );
	},
	"Budget/ReviewBudget": () => {
        return import(
            /* webpackChunkName: "budgetsChunk" */ "@insite/content-library/Widgets/Budget/ReviewBudget"
        );
	},
	"Cart/CartActions": () => {
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartActions"
        );
	},
	"Cart/CartFulfillmentMethodSelector": () => {
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartFulfillmentMethodSelector"
        );
	},
	"Cart/CartHeader": () => {
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartHeader"
        );
	},
	"Cart/CartLineCardCondensed": () => {
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartLineCardCondensed"
        );
	},
	"Cart/CartLineCardExpanded": () => {
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartLineCardExpanded"
        );
	},
	"Cart/CartLineNotes": () => {
        import(/* webpackChunkName: "cartsChunk" */ "@bgs/App/WidgetExtensions/Cart/CartLineNotesExtensions");
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartLineNotes"
        );
	},
	"Cart/CartLineQuantity": () => {
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartLineQuantity"
        );
	},
	"Cart/CartLines": () => {
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartLines"
        );
	},
	"Cart/CartPageContainer": () => {
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartPageContainer"
        );
	},
	"Cart/CartSaveOrderButton": () => {
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartSaveOrderButton"
        );
	},
	"Cart/CartTotal": () => {
        import(/* webpackChunkName: "cartsChunk" */ "@bgs/App/WidgetExtensions/Cart/CartTotalExtension");
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartTotal"
        );
	},
	"CartReminderUnsubscribe/CartReminderUnsubscribeMessage": () => {
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/CartReminderUnsubscribe/CartReminderUnsubscribeMessage"
        );
	},
	"Category/CategoryDetailBanner": () => {
        return import(
            /* webpackChunkName: "categoriesChunk" */ "@insite/content-library/Widgets/Category/CategoryDetailBanner"
        );
	},
	"Category/CategoryDetailLinkList": () => {
        return import(
            /* webpackChunkName: "categoriesChunk" */ "@insite/content-library/Widgets/Category/CategoryDetailLinkList"
        );
	},
	"Category/CategoryDetailSubCategories": () => {
        return import(
            /* webpackChunkName: "categoriesChunk" */ "@insite/content-library/Widgets/Category/CategoryDetailSubCategories"
        );
	},
	"Category/CategoryImage": () => {
        return import(
            /* webpackChunkName: "categoriesChunk" */ "@insite/content-library/Widgets/Category/CategoryImage"
        );
	},
	"Category/CategoryList": () => {
        return import(
            /* webpackChunkName: "categoriesChunk" */ "@insite/content-library/Widgets/Category/CategoryList"
        );
	},
	"Category/CategoryName": () => {
        return import(
            /* webpackChunkName: "categoriesChunk" */ "@insite/content-library/Widgets/Category/CategoryName"
        );
	},
	"ChangeCustomer/ChangeCustomerBillToSelector": () => {
        return import(
            /* webpackChunkName: "changesChunk" */ "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerBillToSelector"
        );
	},
	"ChangeCustomer/ChangeCustomerFulfillmentMethodSelector": () => {
        return import(
            /* webpackChunkName: "changesChunk" */ "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerFulfillmentMethodSelector"
        );
	},
	"ChangeCustomer/ChangeCustomerSelectCustomer": () => {
        return import(
            /* webpackChunkName: "changesChunk" */ "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerSelectCustomer"
        );
	},
	"ChangeCustomer/ChangeCustomerSelectCustomerContainer": () => {
        return import(
            /* webpackChunkName: "changesChunk" */ "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer"
        );
	},
	"ChangeCustomer/ChangeCustomerShipToSelector": () => {
        return import(
            /* webpackChunkName: "changesChunk" */ "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerShipToSelector"
        );
	},
	"ChangePassword/ChangePassword": () => {
        return import(
            /* webpackChunkName: "changesChunk" */ "@insite/content-library/Widgets/ChangePassword/ChangePassword"
        );
	},
	"ChangePassword/ChangePasswordActions": () => {
        return import(
            /* webpackChunkName: "changesChunk" */ "@insite/content-library/Widgets/ChangePassword/ChangePasswordActions"
        );
	},
	"ChangePassword/ChangePasswordHeader": () => {
        return import(
            /* webpackChunkName: "changesChunk" */ "@insite/content-library/Widgets/ChangePassword/ChangePasswordHeader"
        );
	},
	"CheckoutReviewAndSubmit/AdyenDropIn": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/AdyenDropIn"
        );
	},
	"CheckoutReviewAndSubmit/BillingAddressInfoDisplay": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/BillingAddressInfoDisplay"
        );
	},
	"CheckoutReviewAndSubmit/BillingAndShippingInfo": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/BillingAndShippingInfo"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitActionButtons": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitActionButtons"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCarrierService": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCarrierService"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCartTotal": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCartTotal"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitHeader": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitHeader"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPageContainer": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPageContainer"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPaymentDetails": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPaymentDetails"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPlaceOrderButton": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPlaceOrderButton"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitProductList": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitProductList"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitShippingInfo": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitShippingInfo"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitSubmitForApprovalButton": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitSubmitForApprovalButton"
        );
	},
	"CheckoutReviewAndSubmit/CreditCardBillingAddressEntry": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardBillingAddressEntry"
        );
	},
	"CheckoutReviewAndSubmit/CreditCardDetailsEntry": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry"
        );
	},
	"CheckoutReviewAndSubmit/ECheckDetailsEntry": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/ECheckDetailsEntry"
        );
	},
	"CheckoutReviewAndSubmit/PayPalButton": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/PayPalButton"
        );
	},
	"CheckoutReviewAndSubmit/PaymentProfileBillingAddress": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/PaymentProfileBillingAddress"
        );
	},
	"CheckoutReviewAndSubmit/PickUpLocation": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/PickUpLocation"
        );
	},
	"CheckoutReviewAndSubmit/PickUpLocationAddressInfoDisplay": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/PickUpLocationAddressInfoDisplay"
        );
	},
	"CheckoutReviewAndSubmit/SavedPaymentProfileEntry": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/SavedPaymentProfileEntry"
        );
	},
	"CheckoutReviewAndSubmit/ShippingAddressInfoDisplay": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@bgs/App/WidgetExtensions/CheckoutReviewAndSubmit/ShippingAddressInfoDisplayExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/ShippingAddressInfoDisplay"
        );
	},
	"CheckoutShipping/BillingAddress": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/BillingAddress"
        );
	},
	"CheckoutShipping/BillingAddressForm": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/BillingAddressForm"
        );
	},
	"CheckoutShipping/CheckoutShippingAdditionalEmails": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingAdditionalEmails"
        );
	},
	"CheckoutShipping/CheckoutShippingAddresses": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingAddresses"
        );
	},
	"CheckoutShipping/CheckoutShippingCartTotal": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingCartTotal"
        );
	},
	"CheckoutShipping/CheckoutShippingFulfillmentMethodSelector": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingFulfillmentMethodSelector"
        );
	},
	"CheckoutShipping/CheckoutShippingHeader": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingHeader"
        );
	},
	"CheckoutShipping/CheckoutShippingOrderNotesEntry": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingOrderNotesEntry"
        );
	},
	"CheckoutShipping/CheckoutShippingPageContainer": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingPageContainer"
        );
	},
	"CheckoutShipping/CreateNewAddressModal": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/CreateNewAddressModal"
        );
	},
	"CheckoutShipping/EditExistingAddressModal": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/EditExistingAddressModal"
        );
	},
	"CheckoutShipping/PickUpAddress": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/PickUpAddress"
        );
	},
	"CheckoutShipping/ShippingAddress": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/ShippingAddress"
        );
	},
	"CheckoutShipping/ShippingAddressForm": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/ShippingAddressForm"
        );
	},
	"CompactHeader/Cart": () => {
        return import(
            /* webpackChunkName: "compactheaderChunk" */ "@insite/content-library/Widgets/CompactHeader/Cart"
        );
	},
	"CompactHeader/Flyout": () => {
        return import(
            /* webpackChunkName: "compactheaderChunk" */ "@insite/content-library/Widgets/CompactHeader/Flyout"
        );
	},
	"CompactHeader/Logo": () => {
        return import(
            /* webpackChunkName: "compactheaderChunk" */ "@insite/content-library/Widgets/CompactHeader/Logo"
        );
	},
	"CompactHeader/MainNavigation": () => {
        return import(
            /* webpackChunkName: "compactheaderChunk" */ "@insite/content-library/Widgets/CompactHeader/MainNavigation"
        );
	},
	"CompactHeader/Search": () => {
        return import(
            /* webpackChunkName: "compactheaderChunk" */ "@insite/content-library/Widgets/CompactHeader/Search"
        );
	},
	"ContactUs/AvailableTopics": () => {
        return import(
            /* webpackChunkName: "contactusChunk" */ "@insite/content-library/Widgets/ContactUs/AvailableTopics"
        );
	},
	"ContactUs/ContactForm": () => {
        return import(
            /* webpackChunkName: "contactusChunk" */ "@insite/content-library/Widgets/ContactUs/ContactForm"
        );
	},
	"ContactUs/EmailAddress": () => {
        return import(
            /* webpackChunkName: "contactusChunk" */ "@insite/content-library/Widgets/ContactUs/EmailAddress"
        );
	},
	"ContactUs/FirstName": () => {
        return import(
            /* webpackChunkName: "contactusChunk" */ "@insite/content-library/Widgets/ContactUs/FirstName"
        );
	},
	"ContactUs/LastName": () => {
        return import(
            /* webpackChunkName: "contactusChunk" */ "@insite/content-library/Widgets/ContactUs/LastName"
        );
	},
	"ContactUs/Message": () => {
        return import(
            /* webpackChunkName: "contactusChunk" */ "@insite/content-library/Widgets/ContactUs/Message"
        );
	},
	"ContactUs/PhoneNumber": () => {
        return import(
            /* webpackChunkName: "contactusChunk" */ "@insite/content-library/Widgets/ContactUs/PhoneNumber"
        );
	},
	"CreateAccount/CreateAccount": () => {
        return import(
            /* webpackChunkName: "createaccountChunk" */ "@insite/content-library/Widgets/CreateAccount/CreateAccount"
        );
	},
	"DealerDetails/DealerInformation": () => {
        return import(
            /* webpackChunkName: "dealerdetailsChunk" */ "@insite/content-library/Widgets/DealerDetails/DealerInformation"
        );
	},
	"DealerDetails/DealerLocationMap": () => {
        return import(
            /* webpackChunkName: "dealerdetailsChunk" */ "@insite/content-library/Widgets/DealerDetails/DealerLocationMap"
        );
	},
	"InvoiceDetails/InvoiceDetailHeader": () => {
        import(/* webpackChunkName: "invoicesChunk" */ "@bgs/App/WidgetExtensions/InvoiceDetails/InvoiceDetailHeaderExtension");
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailHeader"
        );
	},
	"InvoiceDetails/InvoiceDetailsBillingAddress": () => {
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsBillingAddress"
        );
	},
	"InvoiceDetails/InvoiceDetailsInformation": () => {
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsInformation"
        );
	},
	"InvoiceDetails/InvoiceDetailsLineCard": () => {
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsLineCard"
        );
	},
	"InvoiceDetails/InvoiceDetailsShippingAddress": () => {
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsShippingAddress"
        );
	},
	"InvoiceDetails/InvoiceDetailsSummaryTable": () => {
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsSummaryTable"
        );
	},
	"InvoiceDetails/InvoiceDetailsTotal": () => {
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsTotal"
        );
	},
	"InvoiceHistory/InvoiceHistoryBuckets": () => {
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryBuckets"
        );
	},
	"InvoiceHistory/InvoiceHistoryFilter": () => {
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryFilter"
        );
	},
	"InvoiceHistory/InvoiceHistoryHeader": () => {
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryHeader"
        );
	},
	"InvoiceHistory/InvoiceHistoryPagination": () => {
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryPagination"
        );
	},
	"InvoiceHistory/InvoiceHistoryTable": () => {
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryTable"
        );
	},
	"LocationFinder/LocationFinder": () => {
        return import(
            /* webpackChunkName: "locationfinderChunk" */ "@insite/content-library/Widgets/LocationFinder/LocationFinder"
        );
	},
	"LocationFinder/LocationFinderDealerDisplay": () => {
        return import(
            /* webpackChunkName: "locationfinderChunk" */ "@insite/content-library/Widgets/LocationFinder/LocationFinderDealerDisplay"
        );
	},
	"ManifestJson/ManifestJsonContent": () => {
        return import(
            /* webpackChunkName: "manifestjsonChunk" */ "@insite/content-library/Widgets/ManifestJson/ManifestJsonContent"
        );
	},
	"MyAccount/AccountMessages": () => {
        return import(
            /* webpackChunkName: "myaccountChunk" */ "@insite/content-library/Widgets/MyAccount/AccountMessages"
        );
	},
	"MyAccount/MyAccountHomepageSelector": () => {
        return import(
            /* webpackChunkName: "myaccountChunk" */ "@insite/content-library/Widgets/MyAccount/MyAccountHomepageSelector"
        );
	},
	"MyAccount/MyAccountView": () => {
        return import(
            /* webpackChunkName: "myaccountChunk" */ "@insite/content-library/Widgets/MyAccount/MyAccountView"
        );
	},
	"MyLists/MyListsCreateListButton": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsCreateListButton"
        );
	},
	"MyLists/MyListsEditListForm": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@bgs/App/WidgetExtensions/MyLists/MyListsEditListFormExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsEditListForm"
        );
	},
	"MyLists/MyListsFilter": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@bgs/App/WidgetExtensions/MyLists/MyListsFilterExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsFilter"
        );
	},
	"MyLists/MyListsHeader": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsHeader"
        );
	},
	"MyLists/MyListsList": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsList"
        );
	},
	"MyLists/MyListsPagination": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsPagination"
        );
	},
	"MyLists/MyListsSearchBox": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsSearchBox"
        );
	},
	"MyLists/MyListsSearchFieldBrand": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsSearchFieldBrand"
        );
	},
	"MyLists/MyListsSearchFieldProductNumber": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@bgs/App/WidgetExtensions/MyLists/MyListsSearchFieldProductNumberExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsSearchFieldProductNumber"
        );
	},
	"MyLists/MyListsSearchFieldSharedBy": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsSearchFieldSharedBy"
        );
	},
	"MyLists/MyListsSortControl": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@bgs/App/WidgetExtensions/MyLists/MyListsSortControlExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsSortControl"
        );
	},
	"MyLists/MyListsView": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsView"
        );
	},
	"MyLists/SearchFieldWrapper": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/SearchFieldWrapper"
        );
	},
	"MyListsDetails/AddTagsModal": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/AddTagsModal"
        );
	},
	"MyListsDetails/MyListDetailsDiscontinuedProductListLine": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/MyListDetailsDiscontinuedProductListLine"
        );
	},
	"MyListsDetails/MyListDetailsPagination": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/MyListDetailsPagination"
        );
	},
	"MyListsDetails/MyListsDetailsActions": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@bgs/App/WidgetExtensions/MyListsDetails/MyListsDetailsActionsExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsActions"
        );
	},
	"MyListsDetails/MyListsDetailsCopyListForm": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsCopyListForm"
        );
	},
	"MyListsDetails/MyListsDetailsHeader": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@bgs/App/WidgetExtensions/MyListsDetails/MyListsDetailsHeaderExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsHeader"
        );
	},
	"MyListsDetails/MyListsDetailsOptions": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@bgs/App/WidgetExtensions/MyListsDetails/MyListsDetailsOptionsExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsOptions"
        );
	},
	"MyListsDetails/MyListsDetailsProductList": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductList"
        );
	},
	"MyListsDetails/MyListsDetailsProductListLine": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@bgs/App/WidgetExtensions/MyListsDetails/MyListsDetailsProductListLineExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductListLine"
        );
	},
	"MyListsDetails/ViewReplacementProductModal": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/ViewReplacementProductModal"
        );
	},
	"NewsList/NewsListView": () => {
        return import(
            /* webpackChunkName: "newsChunk" */ "@insite/content-library/Widgets/NewsList/NewsListView"
        );
	},
	"NewsPage/NewsPageView": () => {
        return import(
            /* webpackChunkName: "newsChunk" */ "@insite/content-library/Widgets/NewsPage/NewsPageView"
        );
	},
	"OnePageCheckout/BillToSelectorModal": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/BillToSelectorModal"
        );
	},
	"OnePageCheckout/BillingAddressForm": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/BillingAddressForm"
        );
	},
	"OnePageCheckout/OnePageCheckoutDeliveryMethod": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@bgs/App/WidgetExtensions/OnePageCheckout/OnePageCheckoutDeliveryMethodExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/OnePageCheckoutDeliveryMethod"
        );
	},
	"OnePageCheckout/OnePageCheckoutOrderSummary": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@bgs/App/WidgetExtensions/OnePageCheckout/OnePageCheckoutOrderSummaryExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/OnePageCheckoutOrderSummary"
        );
	},
	"OnePageCheckout/OnePageCheckoutPageContainer": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/OnePageCheckoutPageContainer"
        );
	},
	"OnePageCheckout/OnePageCheckoutPaymentDetails": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@bgs/App/WidgetExtensions/OnePageCheckout/OnePageCheckoutPaymentDetailsExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/OnePageCheckoutPaymentDetails"
        );
	},
	"OnePageCheckout/OnePageCheckoutReviewAndPlaceOrder": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/OnePageCheckoutReviewAndPlaceOrder"
        );
	},
	"OnePageCheckout/OnePageCheckoutShippingSection": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@bgs/App/WidgetExtensions/OnePageCheckout/OnePageCheckoutShippingSectionExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/OnePageCheckoutShippingSection"
        );
	},
	"OnePageCheckout/ShipToSelectorModal": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/ShipToSelectorModal"
        );
	},
	"OnePageCheckout/ShippingAddressForm": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/ShippingAddressForm"
        );
	},
	"OnePageCheckoutConfirmation/OnePageCheckoutConfirmationBillingAndShipping": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@bgs/App/WidgetExtensions/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationBillingAndShippingExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationBillingAndShipping"
        );
	},
	"OnePageCheckoutConfirmation/OnePageCheckoutConfirmationHeader": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationHeader"
        );
	},
	"OnePageCheckoutConfirmation/OnePageCheckoutConfirmationOrderSummary": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@bgs/App/WidgetExtensions/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationOrderSummaryExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationOrderSummary"
        );
	},
	"OnePageCheckoutConfirmation/OnePageCheckoutConfirmationPageContainer": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationPageContainer"
        );
	},
	"OnePageCheckoutConfirmation/OnePageCheckoutConfirmationPaymentMethod": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@bgs/App/WidgetExtensions/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationPaymentMethodExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationPaymentMethod"
        );
	},
	"OnePageCheckoutConfirmation/OnePageCheckoutConfirmationProductList": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@bgs/App/WidgetExtensions/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationProductListExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationProductList"
        );
	},
	"OrderApprovalDetails/OrderApprovalDetailsActionButtons": () => {
        import(/* webpackChunkName: "orderapprovalChunk" */ "@bgs/App/WidgetExtensions/OrderApprovalDetails/OrderApprovalDetailsActionButtonsExtension");
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsActionButtons"
        );
	},
	"OrderApprovalDetails/OrderApprovalDetailsBillingInformation": () => {
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsBillingInformation"
        );
	},
	"OrderApprovalDetails/OrderApprovalDetailsHeader": () => {
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsHeader"
        );
	},
	"OrderApprovalDetails/OrderApprovalDetailsOrderInformation": () => {
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsOrderInformation"
        );
	},
	"OrderApprovalDetails/OrderApprovalDetailsProductList": () => {
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsProductList"
        );
	},
	"OrderApprovalDetails/OrderApprovalDetailsShippingInformation": () => {
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsShippingInformation"
        );
	},
	"OrderApprovalDetails/OrderApprovalDetailsTotal": () => {
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsTotal"
        );
	},
	"OrderApprovalList/OrderApprovalListFilter": () => {
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListFilter"
        );
	},
	"OrderApprovalList/OrderApprovalListHeader": () => {
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListHeader"
        );
	},
	"OrderApprovalList/OrderApprovalListPagination": () => {
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListPagination"
        );
	},
	"OrderApprovalList/OrderApprovalListTable": () => {
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListTable"
        );
	},
	"OrderConfirmation/OrderConfirmationAccountSignUpMessage": () => {
        return import(
            /* webpackChunkName: "orderconfirmationChunk" */ "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationAccountSignUpMessage"
        );
	},
	"OrderConfirmation/OrderConfirmationBillingInformation": () => {
        return import(
            /* webpackChunkName: "orderconfirmationChunk" */ "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationBillingInformation"
        );
	},
	"OrderConfirmation/OrderConfirmationHeader": () => {
        return import(
            /* webpackChunkName: "orderconfirmationChunk" */ "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationHeader"
        );
	},
	"OrderConfirmation/OrderConfirmationOrderInformation": () => {
        return import(
            /* webpackChunkName: "orderconfirmationChunk" */ "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationOrderInformation"
        );
	},
	"OrderConfirmation/OrderConfirmationPageContainer": () => {
        return import(
            /* webpackChunkName: "orderconfirmationChunk" */ "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationPageContainer"
        );
	},
	"OrderConfirmation/OrderConfirmationProductList": () => {
        return import(
            /* webpackChunkName: "orderconfirmationChunk" */ "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationProductList"
        );
	},
	"OrderConfirmation/OrderConfirmationShippingInformation": () => {
        return import(
            /* webpackChunkName: "orderconfirmationChunk" */ "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationShippingInformation"
        );
	},
	"OrderConfirmation/OrderConfirmationTotal": () => {
        return import(
            /* webpackChunkName: "orderconfirmationChunk" */ "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationTotal"
        );
	},
	"OrderDetails/OrderCancel": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderCancel"
        );
	},
	"OrderDetails/OrderCancelNotification": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderCancelNotification"
        );
	},
	"OrderDetails/OrderDate": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDate"
        );
	},
	"OrderDetails/OrderDetailsBillingAddress": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsBillingAddress"
        );
	},
	"OrderDetails/OrderDetailsButtonSet": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@bgs/App/WidgetExtensions/OrderDetails/OrderDetailsButtonSetExtension");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsButtonSet"
        );
	},
	"OrderDetails/OrderDetailsCreditCardBillingAddress": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsCreditCardBillingAddress"
        );
	},
	"OrderDetails/OrderDetailsNotes": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsNotes"
        );
	},
	"OrderDetails/OrderDetailsPaymentTerms": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsPaymentTerms"
        );
	},
	"OrderDetails/OrderDetailsRequestedDate": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsRequestedDate"
        );
	},
	"OrderDetails/OrderDetailsShipmentPackages": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsShipmentPackages"
        );
	},
	"OrderDetails/OrderDetailsShippingAddress": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsShippingAddress"
        );
	},
	"OrderDetails/OrderDetailsShippingMethod": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsShippingMethod"
        );
	},
	"OrderDetails/OrderDetailsStatus": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsStatus"
        );
	},
	"OrderDetails/OrderDetailsSummaryTable": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsSummaryTable"
        );
	},
	"OrderDetails/OrderDetailsTitle": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsTitle"
        );
	},
	"OrderDetails/OrderDetailsTotal": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsTotal"
        );
	},
	"OrderDetails/OrderDetailsVatNumber": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsVatNumber"
        );
	},
	"OrderDetails/OrderDetailsVmiLocation": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsVmiLocation"
        );
	},
	"OrderDetails/OrderPo": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderPo"
        );
	},
	"OrderDetails/OrderSalesperson": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderSalesperson"
        );
	},
	"OrderHistory/OrderHistoryHeader": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistoryHeader"
        );
	},
	"OrderHistory/OrderHistoryPagination": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistoryPagination"
        );
	},
	"OrderHistory/OrderHistoryResultCount": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistoryResultCount"
        );
	},
	"OrderHistory/OrderHistorySearchClearButton": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchClearButton"
        );
	},
	"OrderHistory/OrderHistorySearchField": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchField"
        );
	},
	"OrderHistory/OrderHistorySearchFieldDateRange": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange"
        );
	},
	"OrderHistory/OrderHistorySearchFieldOrderNumber": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldOrderNumber"
        );
	},
	"OrderHistory/OrderHistorySearchFieldOrderTotal": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldOrderTotal"
        );
	},
	"OrderHistory/OrderHistorySearchFieldOrderTotalOperator": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldOrderTotalOperator"
        );
	},
	"OrderHistory/OrderHistorySearchFieldPoNumber": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldPoNumber"
        );
	},
	"OrderHistory/OrderHistorySearchFieldProductErpNumber": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldProductErpNumber"
        );
	},
	"OrderHistory/OrderHistorySearchFieldProductErpNumber2": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldProductErpNumber2"
        );
	},
	"OrderHistory/OrderHistorySearchFieldShipTos": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldShipTos"
        );
	},
	"OrderHistory/OrderHistorySearchFieldShowMyOrders": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldShowMyOrders"
        );
	},
	"OrderHistory/OrderHistorySearchFieldStatus": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldStatus"
        );
	},
	"OrderHistory/OrderHistorySearchFieldVmiLocation": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldVmiLocation"
        );
	},
	"OrderHistory/OrderHistorySearchForm": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchForm"
        );
	},
	"OrderHistory/OrderHistorySearchTags": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchTags"
        );
	},
	"OrderHistory/OrderHistoryTable": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistoryTable"
        );
	},
	"OrderHistory/SearchFieldWrapper": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper"
        );
	},
	"OrderHistory/SearchTextField": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/SearchTextField"
        );
	},
	"OrderStatus/OrderStatusAddressDetails": () => {
        return import(
            /* webpackChunkName: "orderstatusChunk" */ "@insite/content-library/Widgets/OrderStatus/OrderStatusAddressDetails"
        );
	},
	"OrderStatus/OrderStatusForm": () => {
        return import(
            /* webpackChunkName: "orderstatusChunk" */ "@insite/content-library/Widgets/OrderStatus/OrderStatusForm"
        );
	},
	"OrderStatus/OrderStatusHeader": () => {
        return import(
            /* webpackChunkName: "orderstatusChunk" */ "@insite/content-library/Widgets/OrderStatus/OrderStatusHeader"
        );
	},
	"OrderStatus/OrderStatusInformation": () => {
        return import(
            /* webpackChunkName: "orderstatusChunk" */ "@insite/content-library/Widgets/OrderStatus/OrderStatusInformation"
        );
	},
	"OrderStatus/OrderStatusProductList": () => {
        return import(
            /* webpackChunkName: "orderstatusChunk" */ "@insite/content-library/Widgets/OrderStatus/OrderStatusProductList"
        );
	},
	"OrderStatus/OrderStatusShipmentPackages": () => {
        return import(
            /* webpackChunkName: "orderstatusChunk" */ "@insite/content-library/Widgets/OrderStatus/OrderStatusShipmentPackages"
        );
	},
	"OrderStatus/OrderStatusTotal": () => {
        return import(
            /* webpackChunkName: "orderstatusChunk" */ "@insite/content-library/Widgets/OrderStatus/OrderStatusTotal"
        );
	},
	"OrderUpload/OrderUploadFileUpload": () => {
        return import(
            /* webpackChunkName: "orderuploadChunk" */ "@insite/content-library/Widgets/OrderUpload/OrderUploadFileUpload"
        );
	},
	"OrderUpload/OrderUploadPageContainer": () => {
        return import(
            /* webpackChunkName: "orderuploadChunk" */ "@insite/content-library/Widgets/OrderUpload/OrderUploadPageContainer"
        );
	},
	"Product/ProductImage": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/Product/ProductImage"
        );
	},
	"Product/ProductName": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/Product/ProductName"
        );
	},
	"ProductCompare/ProductCompareCarousel": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductCompare/ProductCompareCarousel"
        );
	},
	"ProductDetails/ProductDetailsAddToCartButton": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToCartButton"
        );
	},
	"ProductDetails/ProductDetailsAddToListLink": () => {
        import(/* webpackChunkName: "productsChunk" */ "@bgs/App/WidgetExtensions/ProductDetails/ProductDetailsAddToListLinkExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToListLink"
        );
	},
	"ProductDetails/ProductDetailsAttributes": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsAttributes"
        );
	},
	"ProductDetails/ProductDetailsAvailability": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsAvailability"
        );
	},
	"ProductDetails/ProductDetailsBundleSectionOptions": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsBundleSectionOptions"
        );
	},
	"ProductDetails/ProductDetailsCustomerPartNumber": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsCustomerPartNumber"
        );
	},
	"ProductDetails/ProductDetailsDeliveryScheduleButton": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsDeliveryScheduleButton"
        );
	},
	"ProductDetails/ProductDetailsDescription": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsDescription"
        );
	},
	"ProductDetails/ProductDetailsDocuments": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsDocuments"
        );
	},
	"ProductDetails/ProductDetailsImageBadge": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsImageBadge"
        );
	},
	"ProductDetails/ProductDetailsImageCarousel": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsImageCarousel"
        );
	},
	"ProductDetails/ProductDetailsKitSectionOptions": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsKitSectionOptions"
        );
	},
	"ProductDetails/ProductDetailsManufacturingPartNumber": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsManufacturingPartNumber"
        );
	},
	"ProductDetails/ProductDetailsPageTitle": () => {
        import(/* webpackChunkName: "productsChunk" */ "@bgs/App/WidgetExtensions/ProductDetails/ProductDetailsPageTitleExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle"
        );
	},
	"ProductDetails/ProductDetailsPartNumber": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsPartNumber"
        );
	},
	"ProductDetails/ProductDetailsPrice": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice"
        );
	},
	"ProductDetails/ProductDetailsPrimaryImage": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrimaryImage"
        );
	},
	"ProductDetails/ProductDetailsQuantityBreakPricing": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityBreakPricing"
        );
	},
	"ProductDetails/ProductDetailsQuantityOrdered": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityOrdered"
        );
	},
	"ProductDetails/ProductDetailsShareLink": () => {
        import(/* webpackChunkName: "productsChunk" */ "@bgs/App/WidgetExtensions/ProductDetails/ProductDetailsShareLinkExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsShareLink"
        );
	},
	"ProductDetails/ProductDetailsSpecifications": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsSpecifications"
        );
	},
	"ProductDetails/ProductDetailsTextBadge": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsTextBadge"
        );
	},
	"ProductDetails/ProductDetailsUnitOfMeasureSelect": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsUnitOfMeasureSelect"
        );
	},
	"ProductDetails/ProductDetailsVariantButton": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantButton"
        );
	},
	"ProductDetails/ProductDetailsVariantDropdown": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantDropdown"
        );
	},
	"ProductDetails/ProductDetailsVariantOptions": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantOptions"
        );
	},
	"ProductDetails/ProductDetailsVariantSwatchDropdown": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantSwatchDropdown"
        );
	},
	"ProductDetails/ProductDetailsVariantSwatchGrid": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantSwatchGrid"
        );
	},
	"ProductDetails/ProductDetailsVariantSwatchList": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantSwatchList"
        );
	},
	"ProductDetails/ProductDetailsView": () => {
        import(/* webpackChunkName: "productsChunk" */ "@bgs/App/WidgetExtensions/ProductDetails/ProductDetailsViewExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsView"
        );
	},
	"ProductList/ProductCardSelections": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductCardSelections"
        );
	},
	"ProductList/ProductListActions": () => {
        import(/* webpackChunkName: "productsChunk" */ "@bgs/App/WidgetExtensions/ProductList/ProductListActionsExtension");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListActions"
        );
	},
	"ProductList/ProductListAttributeFilters": () => {
        import(/* webpackChunkName: "productsChunk" */ "@bgs/App/WidgetExtensions/ProductList/ProductListAttributeFiltersExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListAttributeFilters"
        );
	},
	"ProductList/ProductListBrandFilters": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListBrandFilters"
        );
	},
	"ProductList/ProductListCardList": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListCardList"
        );
	},
	"ProductList/ProductListCategoryFilters": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListCategoryFilters"
        );
	},
	"ProductList/ProductListColumns": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListColumns"
        );
	},
	"ProductList/ProductListColumnsDrawer": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListColumnsDrawer"
        );
	},
	"ProductList/ProductListControlsContainer": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListControlsContainer"
        );
	},
	"ProductList/ProductListFilterAccordionSection": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection"
        );
	},
	"ProductList/ProductListFilterList": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListFilterList"
        );
	},
	"ProductList/ProductListFiltersAccordion": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListFiltersAccordion"
        );
	},
	"ProductList/ProductListPagination": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListPagination"
        );
	},
	"ProductList/ProductListPreviouslyPurchasedFilter": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListPreviouslyPurchasedFilter"
        );
	},
	"ProductList/ProductListPriceFilters": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListPriceFilters"
        );
	},
	"ProductList/ProductListProductCard": () => {
        import(/* webpackChunkName: "productsChunk" */ "@bgs/App/WidgetExtensions/ProductList/ProductListProductCardExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListProductCard"
        );
	},
	"ProductList/ProductListProductContext": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListProductContext"
        );
	},
	"ProductList/ProductListProductCount": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListProductCount"
        );
	},
	"ProductList/ProductListProductGridCard": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListProductGridCard"
        );
	},
	"ProductList/ProductListProductImage": () => {
        import(/* webpackChunkName: "productsChunk" */ "@bgs/App/WidgetExtensions/ProductList/ProductListProductImageExtension");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListProductImage"
        );
	},
	"ProductList/ProductListProductInformation": () => {
        import(/* webpackChunkName: "productsChunk" */ "@bgs/App/WidgetExtensions/ProductList/ProductListProductInformationExtension");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListProductInformation"
        );
	},
	"ProductList/ProductListProductLineFilters": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListProductLineFilters"
        );
	},
	"ProductList/ProductListProductTableRow": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListProductTableRow"
        );
	},
	"ProductList/ProductListSearchWithin": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListSearchWithin"
        );
	},
	"ProductList/ProductListSortSelect": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListSortSelect"
        );
	},
	"ProductList/ProductListStockedItemsFilter": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListStockedItemsFilter"
        );
	},
	"ProductList/ProductListSuggestion": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListSuggestion"
        );
	},
	"ProductList/ProductListTable": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListTable"
        );
	},
	"ProductList/ProductListTableViewFilter": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListTableViewFilter"
        );
	},
	"ProductList/ProductListVariantSwatch": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListVariantSwatch"
        );
	},
	"ProductList/ProductListViewSelect": () => {
        import(/* webpackChunkName: "productsChunk" */ "@bgs/App/WidgetExtensions/ProductList/ProductListViewSelectExtension");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListViewSelect"
        );
	},
	"QuickOrder/QuickOrderActions": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/QuickOrder/QuickOrderActions"
        );
	},
	"QuickOrder/QuickOrderPageContainer": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/QuickOrder/QuickOrderPageContainer"
        );
	},
	"QuickOrder/QuickOrderProductList": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/QuickOrder/QuickOrderProductList"
        );
	},
	"QuickOrder/QuickOrderSearch": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/QuickOrder/QuickOrderSearch"
        );
	},
	"RequestRma/RequestRmaButtons": () => {
        return import(
            /* webpackChunkName: "requestrmaChunk" */ "@insite/content-library/Widgets/RequestRma/RequestRmaButtons"
        );
	},
	"RequestRma/RequestRmaHeader": () => {
        return import(
            /* webpackChunkName: "requestrmaChunk" */ "@insite/content-library/Widgets/RequestRma/RequestRmaHeader"
        );
	},
	"RequestRma/RequestRmaInformation": () => {
        return import(
            /* webpackChunkName: "requestrmaChunk" */ "@insite/content-library/Widgets/RequestRma/RequestRmaInformation"
        );
	},
	"RequestRma/RequestRmaNotes": () => {
        return import(
            /* webpackChunkName: "requestrmaChunk" */ "@insite/content-library/Widgets/RequestRma/RequestRmaNotes"
        );
	},
	"RequestRma/RequestRmaProductList": () => {
        return import(
            /* webpackChunkName: "requestrmaChunk" */ "@insite/content-library/Widgets/RequestRma/RequestRmaProductList"
        );
	},
	"RequestRma/RequestRmaProductListButtons": () => {
        return import(
            /* webpackChunkName: "requestrmaChunk" */ "@insite/content-library/Widgets/RequestRma/RequestRmaProductListButtons"
        );
	},
	"RequisitionConfirmation/RequisitionConfirmationAddresses": () => {
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/RequisitionConfirmation/RequisitionConfirmationAddresses"
        );
	},
	"RequisitionConfirmation/RequisitionConfirmationHeader": () => {
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/RequisitionConfirmation/RequisitionConfirmationHeader"
        );
	},
	"RequisitionConfirmation/RequisitionConfirmationPageContainer": () => {
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/RequisitionConfirmation/RequisitionConfirmationPageContainer"
        );
	},
	"RequisitionConfirmation/RequisitionConfirmationProductList": () => {
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/RequisitionConfirmation/RequisitionConfirmationProductList"
        );
	},
	"RequisitionConfirmation/RequisitionConfirmationTotal": () => {
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/RequisitionConfirmation/RequisitionConfirmationTotal"
        );
	},
	"Requisitions/RequisitionsHeader": () => {
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/Requisitions/RequisitionsHeader"
        );
	},
	"Requisitions/RequisitionsProductList": () => {
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/Requisitions/RequisitionsProductList"
        );
	},
	"Requisitions/RequisitionsProductListLine": () => {
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/Requisitions/RequisitionsProductListLine"
        );
	},
	"Requisitions/RequisitionsRequisitionLineRow": () => {
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/Requisitions/RequisitionsRequisitionLineRow"
        );
	},
	"Requisitions/RequisitionsRequisitionLinesTable": () => {
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/Requisitions/RequisitionsRequisitionLinesTable"
        );
	},
	"ResetPassword/ResetPassword": () => {
        return import(
            /* webpackChunkName: "resetpasswordChunk" */ "@insite/content-library/Widgets/ResetPassword/ResetPassword"
        );
	},
	"RfqConfirmation/RfqConfirmationDetails": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqConfirmation/RfqConfirmationDetails"
        );
	},
	"RfqConfirmation/RfqConfirmationHeader": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@bgs/App/WidgetExtensions/RfqConfirmation/RfqConfirmationHeaderExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqConfirmation/RfqConfirmationHeader"
        );
	},
	"RfqConfirmation/RfqConfirmationProductList": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqConfirmation/RfqConfirmationProductList"
        );
	},
	"RfqJobQuoteDetails/RfqJobQuoteDetailsHeader": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqJobQuoteDetails/RfqJobQuoteDetailsHeader"
        );
	},
	"RfqJobQuoteDetails/RfqJobQuoteDetailsInformation": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqJobQuoteDetails/RfqJobQuoteDetailsInformation"
        );
	},
	"RfqJobQuoteDetails/RfqJobQuoteDetailsPageContainer": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqJobQuoteDetails/RfqJobQuoteDetailsPageContainer"
        );
	},
	"RfqJobQuoteDetails/RfqJobQuoteDetailsProductCard": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqJobQuoteDetails/RfqJobQuoteDetailsProductCard"
        );
	},
	"RfqJobQuoteDetails/RfqJobQuoteDetailsProductList": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqJobQuoteDetails/RfqJobQuoteDetailsProductList"
        );
	},
	"RfqJobQuotes/RfqJobQuotesPagination": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqJobQuotes/RfqJobQuotesPagination"
        );
	},
	"RfqJobQuotes/RfqJobQuotesTable": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqJobQuotes/RfqJobQuotesTable"
        );
	},
	"RfqJobQuotes/RfqJobQuotesTypeSelector": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqJobQuotes/RfqJobQuotesTypeSelector"
        );
	},
	"RfqMyQuotes/RfqMyQuotesFilter": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesFilter"
        );
	},
	"RfqMyQuotes/RfqMyQuotesHeader": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesHeader"
        );
	},
	"RfqMyQuotes/RfqMyQuotesPagination": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesPagination"
        );
	},
	"RfqMyQuotes/RfqMyQuotesTable": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesTable"
        );
	},
	"RfqMyQuotes/RfqMyQuotesTypeSelector": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesTypeSelector"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsCustomerProductList": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsCustomerProductList"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsHeader": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@bgs/App/WidgetExtensions/RfqQuoteDetails/RfqQuoteDetailsHeaderExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsHeader"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsInformation": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsInformation"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsMessages": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@bgs/App/WidgetExtensions/RfqQuoteDetails/RfqQuoteDetailsMessagesExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsMessages"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsPageContainer": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsPageContainer"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsProductList": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsProductList"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGrid": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGrid"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGridItem": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@bgs/App/WidgetExtensions/RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGridItemExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGridItem"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculator": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@bgs/App/WidgetExtensions/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculatorExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculator"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculatorRow": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@bgs/App/WidgetExtensions/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculatorRowExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculatorRow"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsQuotedPricing": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@bgs/App/WidgetExtensions/RfqQuoteDetails/RfqQuoteDetailsQuotedPricingExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuotedPricing"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsRequestedDetailsGrid": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsRequestedDetailsGrid"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsSalesRepProductList": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsSalesRepProductList"
        );
	},
	"RfqRequestQuote/RfqRequestQuoteHeader": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqRequestQuote/RfqRequestQuoteHeader"
        );
	},
	"RfqRequestQuote/RfqRequestQuotePageContainer": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqRequestQuote/RfqRequestQuotePageContainer"
        );
	},
	"RfqRequestQuote/RfqRequestQuoteProductList": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqRequestQuote/RfqRequestQuoteProductList"
        );
	},
	"RfqRequestQuote/RfqRequestQuoteSpecifications": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@bgs/App/WidgetExtensions/Rfq/RfqRequestQuoteSpecificationsExtension");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqRequestQuote/RfqRequestQuoteSpecifications"
        );
	},
	"RobotsTxt/RobotsTxtContent": () => {
        return import(
            /* webpackChunkName: "robotstxtChunk" */ "@insite/content-library/Widgets/RobotsTxt/RobotsTxtContent"
        );
	},
	"SavedOrderDetails/SavedOrderDetailsActionButtons": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@bgs/App/WidgetExtensions/SavedOrderDetails/SavedOrderDetailsActionButtonsExtension");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsActionButtons"
        );
	},
	"SavedOrderDetails/SavedOrderDetailsAddressModal": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsAddressModal"
        );
	},
	"SavedOrderDetails/SavedOrderDetailsCartLine": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsCartLine"
        );
	},
	"SavedOrderDetails/SavedOrderDetailsHeader": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsHeader"
        );
	},
	"SavedOrderDetails/SavedOrderDetailsOrderInformation": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsOrderInformation"
        );
	},
	"SavedOrderDetails/SavedOrderDetailsProductList": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsProductList"
        );
	},
	"SavedOrderDetails/SavedOrderDetailsTotal": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsTotal"
        );
	},
	"SavedOrderList/SavedOrderListFilter": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/SavedOrderList/SavedOrderListFilter"
        );
	},
	"SavedOrderList/SavedOrderListHeader": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/SavedOrderList/SavedOrderListHeader"
        );
	},
	"SavedOrderList/SavedOrderListPagination": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/SavedOrderList/SavedOrderListPagination"
        );
	},
	"SavedOrderList/SavedOrderListTable": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/SavedOrderList/SavedOrderListTable"
        );
	},
	"SavedPayments/PaymentUtilities": () => {
        return import(
            /* webpackChunkName: "savedpaymentsChunk" */ "@insite/content-library/Widgets/SavedPayments/PaymentUtilities"
        );
	},
	"SavedPayments/PaymetricDetailsEntry": () => {
        return import(
            /* webpackChunkName: "savedpaymentsChunk" */ "@insite/content-library/Widgets/SavedPayments/PaymetricDetailsEntry"
        );
	},
	"SavedPayments/SavedPaymentsAddCardButton": () => {
        return import(
            /* webpackChunkName: "savedpaymentsChunk" */ "@insite/content-library/Widgets/SavedPayments/SavedPaymentsAddCardButton"
        );
	},
	"SavedPayments/SavedPaymentsCardList": () => {
        return import(
            /* webpackChunkName: "savedpaymentsChunk" */ "@insite/content-library/Widgets/SavedPayments/SavedPaymentsCardList"
        );
	},
	"SavedPayments/SavedPaymentsDefaultCard": () => {
        return import(
            /* webpackChunkName: "savedpaymentsChunk" */ "@insite/content-library/Widgets/SavedPayments/SavedPaymentsDefaultCard"
        );
	},
	"SavedPayments/SavedPaymentsEditCardModal": () => {
        return import(
            /* webpackChunkName: "savedpaymentsChunk" */ "@insite/content-library/Widgets/SavedPayments/SavedPaymentsEditCardModal"
        );
	},
	"SavedPayments/SavedPaymentsView": () => {
        return import(
            /* webpackChunkName: "savedpaymentsChunk" */ "@insite/content-library/Widgets/SavedPayments/SavedPaymentsView"
        );
	},
	"ServiceWorkerJs/ServiceWorkerJsContent": () => {
        return import(
            /* webpackChunkName: "serviceworkerjsChunk" */ "@insite/content-library/Widgets/ServiceWorkerJs/ServiceWorkerJsContent"
        );
	},
	"StaticList/StaticListHeader": () => {
        return import(
            /* webpackChunkName: "staticlistChunk" */ "@insite/content-library/Widgets/StaticList/StaticListHeader"
        );
	},
	"StaticList/StaticListProductList": () => {
        return import(
            /* webpackChunkName: "staticlistChunk" */ "@insite/content-library/Widgets/StaticList/StaticListProductList"
        );
	},
	"StaticList/StaticListProductListLine": () => {
        return import(
            /* webpackChunkName: "staticlistChunk" */ "@insite/content-library/Widgets/StaticList/StaticListProductListLine"
        );
	},
	"StorePickupOverlay/StorePickup": () => {
        return import(
            /* webpackChunkName: "storepickupoverlayChunk" */ "@insite/content-library/Widgets/StorePickupOverlay/StorePickup"
        );
	},
	"UserList/CreateUserModal": () => {
        return import(
            /* webpackChunkName: "usersChunk" */ "@insite/content-library/Widgets/UserList/CreateUserModal"
        );
	},
	"UserList/UserListHeader": () => {
        return import(
            /* webpackChunkName: "usersChunk" */ "@insite/content-library/Widgets/UserList/UserListHeader"
        );
	},
	"UserList/UserListUsersTable": () => {
        return import(
            /* webpackChunkName: "usersChunk" */ "@insite/content-library/Widgets/UserList/UserListUsersTable"
        );
	},
	"UserSetup/AssignShipToAddressModal": () => {
        return import(
            /* webpackChunkName: "usersChunk" */ "@insite/content-library/Widgets/UserSetup/AssignShipToAddressModal"
        );
	},
	"UserSetup/UserSetupHeader": () => {
        return import(
            /* webpackChunkName: "usersChunk" */ "@insite/content-library/Widgets/UserSetup/UserSetupHeader"
        );
	},
	"UserSetup/UserSetupSettings": () => {
        return import(
            /* webpackChunkName: "usersChunk" */ "@insite/content-library/Widgets/UserSetup/UserSetupSettings"
        );
	},
	"UserSetup/UserSetupStatus": () => {
        return import(
            /* webpackChunkName: "usersChunk" */ "@insite/content-library/Widgets/UserSetup/UserSetupStatus"
        );
	},
	"UserSetup/UserSetupUserInformation": () => {
        return import(
            /* webpackChunkName: "usersChunk" */ "@insite/content-library/Widgets/UserSetup/UserSetupUserInformation"
        );
	},
	"VmiBinDetails/SearchUserField": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/SearchUserField"
        );
	},
	"VmiBinDetails/VmiBinDetailsButtons": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsButtons"
        );
	},
	"VmiBinDetails/VmiBinDetailsCountsActions": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsCountsActions"
        );
	},
	"VmiBinDetails/VmiBinDetailsCountsFilter": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsCountsFilter"
        );
	},
	"VmiBinDetails/VmiBinDetailsCountsPagination": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsCountsPagination"
        );
	},
	"VmiBinDetails/VmiBinDetailsCountsTable": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsCountsTable"
        );
	},
	"VmiBinDetails/VmiBinDetailsOrdersActions": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsOrdersActions"
        );
	},
	"VmiBinDetails/VmiBinDetailsOrdersFilter": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsOrdersFilter"
        );
	},
	"VmiBinDetails/VmiBinDetailsOrdersPagination": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsOrdersPagination"
        );
	},
	"VmiBinDetails/VmiBinDetailsOrdersTable": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsOrdersTable"
        );
	},
	"VmiBinDetails/VmiBinDetailsProductInfo": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsProductInfo"
        );
	},
	"VmiBinDetails/VmiBinDetailsTabbedTable": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsTabbedTable"
        );
	},
	"VmiBinDetails/VmiBinDetailsTitle": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsTitle"
        );
	},
	"VmiBins/VmiBinsActions": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBins/VmiBinsActions"
        );
	},
	"VmiBins/VmiBinsFilter": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBins/VmiBinsFilter"
        );
	},
	"VmiBins/VmiBinsHeader": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBins/VmiBinsHeader"
        );
	},
	"VmiBins/VmiBinsPagination": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBins/VmiBinsPagination"
        );
	},
	"VmiBins/VmiBinsTable": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBins/VmiBinsTable"
        );
	},
	"VmiDashboard/VmiDashboardBelowMinimum": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiDashboard/VmiDashboardBelowMinimum"
        );
	},
	"VmiDashboard/VmiDashboardFastMoving": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiDashboard/VmiDashboardFastMoving"
        );
	},
	"VmiDashboard/VmiDashboardHeader": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiDashboard/VmiDashboardHeader"
        );
	},
	"VmiDashboard/VmiDashboardRecentNotes": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiDashboard/VmiDashboardRecentNotes"
        );
	},
	"VmiDashboard/VmiDashboardSlowMoving": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiDashboard/VmiDashboardSlowMoving"
        );
	},
	"VmiLocationDetails/VmiLocationDetailsButtons": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocationDetails/VmiLocationDetailsButtons"
        );
	},
	"VmiLocationDetails/VmiLocationDetailsCustomerInfo": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocationDetails/VmiLocationDetailsCustomerInfo"
        );
	},
	"VmiLocationDetails/VmiLocationDetailsTabbedTable": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocationDetails/VmiLocationDetailsTabbedTable"
        );
	},
	"VmiLocationDetails/VmiLocationDetailsTitle": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocationDetails/VmiLocationDetailsTitle"
        );
	},
	"VmiLocations/AddVmiLocationModal": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocations/AddVmiLocationModal"
        );
	},
	"VmiLocations/VmiLocationsActions": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocations/VmiLocationsActions"
        );
	},
	"VmiLocations/VmiLocationsHeader": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocations/VmiLocationsHeader"
        );
	},
	"VmiLocations/VmiLocationsPagination": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocations/VmiLocationsPagination"
        );
	},
	"VmiLocations/VmiLocationsSearchBox": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocations/VmiLocationsSearchBox"
        );
	},
	"VmiLocations/VmiLocationsTable": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocations/VmiLocationsTable"
        );
	},
	"VmiReporting/SearchTextField": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiReporting/SearchTextField"
        );
	},
	"VmiReporting/VmiBinsActions": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiReporting/VmiBinsActions"
        );
	},
	"VmiReporting/VmiBinsFilter": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiReporting/VmiBinsFilter"
        );
	},
	"VmiReporting/VmiBinsMetricFilter": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiReporting/VmiBinsMetricFilter"
        );
	},
	"VmiReporting/VmiBinsPagination": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiReporting/VmiBinsPagination"
        );
	},
	"VmiReporting/VmiBinsTable": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiReporting/VmiBinsTable"
        );
	},
	"VmiReporting/VmiReportingHeader": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiReporting/VmiReportingHeader"
        );
	},
	"VmiUsers/AddVmiUserModal": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiUsers/AddVmiUserModal"
        );
	},
	"VmiUsers/VmiLocationsTable": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiUsers/VmiLocationsTable"
        );
	},
	"VmiUsers/VmiUsersHeader": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiUsers/VmiUsersHeader"
        );
	},
	"VmiUsers/VmiUsersPagination": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiUsers/VmiUsersPagination"
        );
	},
	"VmiUsers/VmiUsersTable": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiUsers/VmiUsersTable"
        );
	},
	"AboutUs/AboutUsRow": () => {
        return import(
            /* webpackChunkName: "bgsaboutusChunk" */ "@bgs/App/Widgets/AboutUs/AboutUsRow"
        );
	},
	"AccountSettings/AccountSettingsManageBillTrust": () => {
        return import(
            /* webpackChunkName: "bgsaccountsettingsChunk" */ "@bgs/App/Widgets/AccountSettings/AccountSettingsManageBillTrust"
        );
	},
	"FeaturedProducts/ShopByLookBanner": () => {
        return import(
            /* webpackChunkName: "bgsproductsChunk" */ "@bgs/App/Widgets/FeaturedProducts/ShopByLookBanner"
        );
	},
	"GlobalWebsiteMessage/GlobalWebsiteMessage": () => {
        return import(
            /* webpackChunkName: "bgsglobalwebsitemessageChunk" */ "@bgs/App/Widgets/GlobalWebsiteMessage/GlobalWebsiteMessage"
        );
	},
	"Instagram/Instagram": () => {
        return import(
            /* webpackChunkName: "bgsinstagramChunk" */ "@bgs/App/Widgets/Instagram/Instagram"
        );
	},
	"LookBook/LookBook": () => {
        return import(
            /* webpackChunkName: "bgslookbookChunk" */ "@bgs/App/Widgets/LookBook/LookBook"
        );
	},
	"OnePageCheckout/OnePageCheckoutOrderDetails": () => {
        import(/* webpackChunkName: "bgscheckoutsChunk" */ "@bgs/App/WidgetExtensions/OnePageCheckout/OnePageCheckoutOrderDetailsExtensions");
        return import(
            /* webpackChunkName: "bgscheckoutsChunk" */ "@bgs/App/Widgets/OnePageCheckout/OnePageCheckoutOrderDetails"
        );
	},
	"OnePageCheckout/OnePageCheckoutProductList": () => {
        return import(
            /* webpackChunkName: "bgscheckoutsChunk" */ "@bgs/App/Widgets/OnePageCheckout/OnePageCheckoutProductList"
        );
	},
	"OnePageCheckoutConfirmation/OnePageCheckoutConfirmationDeliveryMethod": () => {
        import(/* webpackChunkName: "bgscheckoutsChunk" */ "@bgs/App/WidgetExtensions/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationDeliveryMethodExtensions");
        return import(
            /* webpackChunkName: "bgscheckoutsChunk" */ "@bgs/App/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationDeliveryMethod"
        );
	},
	"ProjectPlanner/ProjectPlanner": () => {
        return import(
            /* webpackChunkName: "bgsprojectplannerChunk" */ "@bgs/App/Widgets/ProjectPlanner/ProjectPlanner"
        );
	},
	"ShopByLook/ShopByLook": () => {
        return import(
            /* webpackChunkName: "bgsshopbylookChunk" */ "@bgs/App/Widgets/ShopByLook/ShopByLook"
        );
	},
	"ShopByLook/ShopByLookProduct": () => {
        return import(
            /* webpackChunkName: "bgsshopbylookChunk" */ "@bgs/App/Widgets/ShopByLook/ShopByLookProduct"
        );
	},
	"ShopByLook/ShopByLookProducts": () => {
        return import(
            /* webpackChunkName: "bgsshopbylookChunk" */ "@bgs/App/Widgets/ShopByLook/ShopByLookProducts"
        );
	},
	"SponsoredLogos/SponsoredLogos": () => {
        return import(
            /* webpackChunkName: "bgssponsoredlogosChunk" */ "@bgs/App/Widgets/SponsoredLogos/SponsoredLogos"
        );
	},
	"XNewsList/XNewsItem": () => {
        return import(
            /* webpackChunkName: "bgsnewsChunk" */ "@bgs/App/Widgets/XNewsList/XNewsItem"
        );
	},
	"XNewsList/XNewsList": () => {
        return import(
            /* webpackChunkName: "bgsnewsChunk" */ "@bgs/App/Widgets/XNewsList/XNewsList"
        );
	},
	"XngBookingAppointmentDrawer/XngBookingAppointmentDrawer": () => {
        return import(
            /* webpackChunkName: "bgsxngbookingappointmentdrawerChunk" */ "@bgs/App/Widgets/XngBookingAppointmentDrawer/XngBookingAppointmentDrawer"
        );
	},
    AccountSettingsPage: () => {
            return import(
                /* webpackChunkName: "accountsettingsChunk" */ "@insite/content-library/Pages/AccountSettingsPage"
            );
        },
    AddressBookOverlay: () => {
            return import(
                /* webpackChunkName: "addressbookoverlay.tsxChunk" */ "@insite/content-library/Pages/AddressBookOverlay"
            );
        },
    AddressesPage: () => {
            return import(
                /* webpackChunkName: "addressesChunk" */ "@insite/content-library/Pages/AddressesPage"
            );
        },
    BrandDetailsPage: () => {
            return import(
                /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Pages/BrandDetailsPage"
            );
        },
    BrandsPage: () => {
            return import(
                /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Pages/BrandsPage"
            );
        },
    BudgetManagementPage: () => {
            return import(
                /* webpackChunkName: "budgetsChunk" */ "@insite/content-library/Pages/BudgetManagementPage"
            );
        },
    CartPage: () => {
            return import(
                /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Pages/CartPage"
            );
        },
    CartReminderUnsubscribePage: () => {
            return import(
                /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Pages/CartReminderUnsubscribePage"
            );
        },
    CategoryDetailsPage: () => {
            return import(
                /* webpackChunkName: "categoriesChunk" */ "@insite/content-library/Pages/CategoryDetailsPage"
            );
        },
    CategoryListPage: () => {
            return import(
                /* webpackChunkName: "categoriesChunk" */ "@insite/content-library/Pages/CategoryListPage"
            );
        },
    ChangeCustomerPage: () => {
            return import(
                /* webpackChunkName: "changesChunk" */ "@insite/content-library/Pages/ChangeCustomerPage"
            );
        },
    ChangePasswordPage: () => {
            return import(
                /* webpackChunkName: "changesChunk" */ "@insite/content-library/Pages/ChangePasswordPage"
            );
        },
    CheckoutReviewAndSubmitPage: () => {
            return import(
                /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Pages/CheckoutReviewAndSubmitPage"
            );
        },
    CheckoutShippingPage: () => {
            return import(
                /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Pages/CheckoutShippingPage"
            );
        },
    CreateAccountPage: () => {
            return import(
                /* webpackChunkName: "createaccountChunk" */ "@insite/content-library/Pages/CreateAccountPage"
            );
        },
    DealerDetailsPage: () => {
            return import(
                /* webpackChunkName: "dealerdetailsChunk" */ "@insite/content-library/Pages/DealerDetailsPage"
            );
        },
    ExpiredAccountActivationLinkPage: () => {
            return import(
                /* webpackChunkName: "expiredaccountactivationlinkChunk" */ "@insite/content-library/Pages/ExpiredAccountActivationLinkPage"
            );
        },
    ExpiredResetPasswordLinkPage: () => {
            return import(
                /* webpackChunkName: "expiredresetpasswordlinkChunk" */ "@insite/content-library/Pages/ExpiredResetPasswordLinkPage"
            );
        },
    InvoiceDetailsPage: () => {
            return import(
                /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Pages/InvoiceDetailsPage"
            );
        },
    InvoiceHistoryPage: () => {
            return import(
                /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Pages/InvoiceHistoryPage"
            );
        },
    LocationFinderPage: () => {
            return import(
                /* webpackChunkName: "locationfinderChunk" */ "@insite/content-library/Pages/LocationFinderPage"
            );
        },
    MaintenancePage: () => {
            return import(
                /* webpackChunkName: "maintenanceChunk" */ "@insite/content-library/Pages/MaintenancePage"
            );
        },
    ManifestJsonPage: () => {
            return import(
                /* webpackChunkName: "manifestjsonChunk" */ "@insite/content-library/Pages/ManifestJsonPage"
            );
        },
    MyAccountPage: () => {
            return import(
                /* webpackChunkName: "myaccountChunk" */ "@insite/content-library/Pages/MyAccountPage"
            );
        },
    MyListsDetailsPage: () => {
            return import(
                /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Pages/MyListsDetailsPage"
            );
        },
    MyListsPage: () => {
            return import(
                /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Pages/MyListsPage"
            );
        },
    NewsListPage: () => {
            return import(
                /* webpackChunkName: "newsChunk" */ "@insite/content-library/Pages/NewsListPage"
            );
        },
    NewsPage: () => {
            return import(
                /* webpackChunkName: "newsChunk" */ "@insite/content-library/Pages/NewsPage"
            );
        },
    NotFoundErrorPage: () => {
            return import(
                /* webpackChunkName: "notfounderrorChunk" */ "@insite/content-library/Pages/NotFoundErrorPage"
            );
        },
    OnePageCheckoutConfirmationPage: () => {
            return import(
                /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Pages/OnePageCheckoutConfirmationPage"
            );
        },
    OnePageCheckoutPage: () => {
            return import(
                /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Pages/OnePageCheckoutPage"
            );
        },
    OrderApprovalDetailsPage: () => {
            return import(
                /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Pages/OrderApprovalDetailsPage"
            );
        },
    OrderApprovalListPage: () => {
            return import(
                /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Pages/OrderApprovalListPage"
            );
        },
    OrderConfirmationPage: () => {
            return import(
                /* webpackChunkName: "orderconfirmationChunk" */ "@insite/content-library/Pages/OrderConfirmationPage"
            );
        },
    OrderDetailsPage: () => {
            return import(
                /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Pages/OrderDetailsPage"
            );
        },
    OrderHistoryPage: () => {
            return import(
                /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Pages/OrderHistoryPage"
            );
        },
    OrderStatusPage: () => {
            return import(
                /* webpackChunkName: "orderstatusChunk" */ "@insite/content-library/Pages/OrderStatusPage"
            );
        },
    OrderUploadPage: () => {
            return import(
                /* webpackChunkName: "orderuploadChunk" */ "@insite/content-library/Pages/OrderUploadPage"
            );
        },
    Page: () => {
            return import(
                /* webpackChunkName: "pageChunk" */ "@insite/content-library/Pages/Page"
            );
        },
    ProductComparePage: () => {
            return import(
                /* webpackChunkName: "productsChunk" */ "@insite/content-library/Pages/ProductComparePage"
            );
        },
    ProductDetailsPage: () => {
            return import(
                /* webpackChunkName: "productsChunk" */ "@insite/content-library/Pages/ProductDetailsPage"
            );
        },
    ProductListPage: () => {
            return import(
                /* webpackChunkName: "productsChunk" */ "@insite/content-library/Pages/ProductListPage"
            );
        },
    QuickOrderPage: () => {
            return import(
                /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Pages/QuickOrderPage"
            );
        },
    RequestRmaPage: () => {
            return import(
                /* webpackChunkName: "requestrmaChunk" */ "@insite/content-library/Pages/RequestRmaPage"
            );
        },
    RequisitionConfirmationPage: () => {
            return import(
                /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Pages/RequisitionConfirmationPage"
            );
        },
    RequisitionsPage: () => {
            return import(
                /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Pages/RequisitionsPage"
            );
        },
    ResetPasswordPage: () => {
            return import(
                /* webpackChunkName: "resetpasswordChunk" */ "@insite/content-library/Pages/ResetPasswordPage"
            );
        },
    RfqConfirmationPage: () => {
            return import(
                /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Pages/RfqConfirmationPage"
            );
        },
    RfqJobQuoteDetailsPage: () => {
            return import(
                /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Pages/RfqJobQuoteDetailsPage"
            );
        },
    RfqJobQuotesPage: () => {
            return import(
                /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Pages/RfqJobQuotesPage"
            );
        },
    RfqMyQuotesPage: () => {
            return import(
                /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Pages/RfqMyQuotesPage"
            );
        },
    RfqQuoteDetailsPage: () => {
            return import(
                /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Pages/RfqQuoteDetailsPage"
            );
        },
    RfqRequestQuotePage: () => {
            return import(
                /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Pages/RfqRequestQuotePage"
            );
        },
    RobotsTxtPage: () => {
            return import(
                /* webpackChunkName: "robotstxtChunk" */ "@insite/content-library/Pages/RobotsTxtPage"
            );
        },
    SavedOrderDetailsPage: () => {
            return import(
                /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Pages/SavedOrderDetailsPage"
            );
        },
    SavedOrderListPage: () => {
            return import(
                /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Pages/SavedOrderListPage"
            );
        },
    SavedPaymentsPage: () => {
            return import(
                /* webpackChunkName: "savedpaymentsChunk" */ "@insite/content-library/Pages/SavedPaymentsPage"
            );
        },
    ServiceWorkerJsPage: () => {
            return import(
                /* webpackChunkName: "serviceworkerjsChunk" */ "@insite/content-library/Pages/ServiceWorkerJsPage"
            );
        },
    SignInOverlay: () => {
            return import(
                /* webpackChunkName: "signinoverlay.tsxChunk" */ "@insite/content-library/Pages/SignInOverlay"
            );
        },
    StaticListPage: () => {
            return import(
                /* webpackChunkName: "staticlistChunk" */ "@insite/content-library/Pages/StaticListPage"
            );
        },
    StorePickupOverlay: () => {
            return import(
                /* webpackChunkName: "storepickupoverlay.tsxChunk" */ "@insite/content-library/Pages/StorePickupOverlay"
            );
        },
    UnhandledErrorPage: () => {
            return import(
                /* webpackChunkName: "unhandlederrorChunk" */ "@insite/content-library/Pages/UnhandledErrorPage"
            );
        },
    UserListPage: () => {
            return import(
                /* webpackChunkName: "usersChunk" */ "@insite/content-library/Pages/UserListPage"
            );
        },
    UserSetupPage: () => {
            return import(
                /* webpackChunkName: "usersChunk" */ "@insite/content-library/Pages/UserSetupPage"
            );
        },
    VmiBinDetailsPage: () => {
            return import(
                /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Pages/VmiBinDetailsPage"
            );
        },
    VmiBinsPage: () => {
            return import(
                /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Pages/VmiBinsPage"
            );
        },
    VmiDashboardPage: () => {
            return import(
                /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Pages/VmiDashboardPage"
            );
        },
    VmiLocationDetailsPage: () => {
            return import(
                /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Pages/VmiLocationDetailsPage"
            );
        },
    VmiLocationsPage: () => {
            return import(
                /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Pages/VmiLocationsPage"
            );
        },
    VmiOrderDetailsPage: () => {
            return import(
                /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Pages/VmiOrderDetailsPage"
            );
        },
    VmiOrderHistoryPage: () => {
            return import(
                /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Pages/VmiOrderHistoryPage"
            );
        },
    VmiReportingPage: () => {
            return import(
                /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Pages/VmiReportingPage"
            );
        },
    VmiUsersPage: () => {
            return import(
                /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Pages/VmiUsersPage"
            );
        },
        
    }
	export default importChunkObj
